const PGAdapter = require('./pg-adapter')

/**
 * Generic PGAdapter for raw external data tables.
 * Defaults to raw.external_stock_data but accepts a tableName to be reused for other raw tables.
 */
const columnPreparers = {
  created_at: (key, value) => {
    return [{
      statement: `"${key}">=%INDEX%::date`,
      value
    }]
  }
}
class RawExternalDataPGAdapter extends PGAdapter {
  constructor ({ pgConnection, username, logger, tableName = 'raw.external_stock_data', extraColumns = [] }) {
    const columns = [
      'id',
      'organisation_id',
      'data',
      'created_at',
      'updated_at',
      ...extraColumns
    ]

    super(
      pgConnection,
      tableName,
      username,
      columns,
      'id',
      columnPreparers,
      logger
    )
  }

  /**
   * Get all raw records for an organization
   * @param {String} organisationId - Organization ID
   * @param {String} date - Optional date filter
   * @param {Object} options - Optional parameters
   * @returns {Promise<Array>} - Array of raw records
   */
  async getByOrganisation (organisationId, date = null, options = {}) {
    // Callers can pass arbitrary extra column filters via options.filters
    // Unknown columns are ignored by the base where-clause builder.
    const filter = { ...(options.filters || {}), organisation_id: organisationId }
    if (date) {
      filter.created_at = date
    }
    const { results } = await this.getList({
      filter,
      ordering: '-created_at',
      limit: Number.MAX_SAFE_INTEGER,
      client: options.client
    })

    return results
  }
}

module.exports = RawExternalDataPGAdapter
